import {Children, ComponentType, isValidElement, JSXElementConstructor, ReactNode} from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyComponent = ComponentType<any> | JSXElementConstructor<any>;

type ComponentTypeOrTypes = AnyComponent | Array<AnyComponent>;

export function hasChildOfType(children: ReactNode, componentType: ComponentTypeOrTypes): boolean {
    const types = Array.isArray(componentType) ? componentType : [componentType];

    return Children.toArray(children).some((child) => isValidElement(child) && types.includes(child.type as AnyComponent));
}
